import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import { TableCell, IconButton, Stack } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const BadgesDataCell = ({ column, value, valueId, key }) => {
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const [isSticky, setIsSticky] = useState(false);

  const handleTooltipToggle = (id) => {
    if (openTooltipId === id) {
      setOpenTooltipId(null);
    } else {
      setOpenTooltipId(id);
    }
  };

  const NoMaxWidthTooltip = styled(({ className, ...props }) => (
    // eslint-disable-next-line
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 'none',
    },
  });

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isSticky) return;

      // Close the tooltip if the mouse is not over the tooltip or the button
      const isOverTooltip = e.target?.closest(`.${tooltipClasses.tooltip}`);
      const isOverButton = e.target?.closest('button'); // Assuming only the IconButton triggers the tooltip

      if (!isOverTooltip && !isOverButton) {
        setOpenTooltipId(null);
      }
    };

    const handleOutsideClick = (e) => {
      setIsSticky(false);
      if (!e.target.closest('.tooltip-target')) {
        setOpenTooltipId(null);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isSticky, openTooltipId]);

  return (
    <TableCell key={column.id}>
      <Stack direction="row">
        {column.render(value).map((status) => {
          const uniqueId = `${key}-${valueId}-${status.id}`;
          return (
            <NoMaxWidthTooltip
              key={uniqueId}
              title={<pre>{status.message}</pre>}
              open={openTooltipId === uniqueId}
              disableHoverListener={openTooltipId === uniqueId}
              disableFocusListener={openTooltipId === uniqueId}
            >
              <IconButton
                onClick={() => {
                  handleTooltipToggle(uniqueId);
                  setIsSticky(true);
                }}
                onMouseEnter={() => {
                  if (!openTooltipId) {
                    // Ensure no tooltip is hovered when another is clicked open
                    setOpenTooltipId(uniqueId);
                  }
                }}
                onMouseLeave={() => {
                  if (!isSticky) setOpenTooltipId(null);
                }}
                color={status.color}
              >
                <status.icon />
              </IconButton>
            </NoMaxWidthTooltip>
          );
        })}
      </Stack>
    </TableCell>
  );
};

export default connect()(BadgesDataCell);
